import cn from 'classnames';
import {Color, Size} from '../../types';
import './button.scss';
import React from 'react';

export interface ButtonProps {
    size?: Size;
    color?: Color;
    onClick: React.MouseEventHandler<HTMLDivElement>;
    className?: string;
    children: JSX.Element
}

export const Button: React.FC<ButtonProps> = ({size, color, children, onClick, className}) => {
    return (
        <div className={cn('button', `--${size}`, `--${color}`, className)} onClick={onClick}>
            {children}
        </div>
    );
}

Button.defaultProps = {
    size: 'normal',
    color: 'blue',
    className: '',
};
